module.exports = __webpack_public_path__ + "img/service-fenan3.192694fe.svg";